"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingRoot = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LoadingRoot = _styledComponents["default"].div.withConfig({
  displayName: "styles__LoadingRoot",
  componentId: "sc-1ui2le5-0"
})(["", " & path{stroke:", ";}"], function (props) {
  return props.state === _constants.States.Loading && 'transform: scaleY(-1);';
}, function (props) {
  return props.color;
});

exports.LoadingRoot = LoadingRoot;